import router from '@/router/router';
import store from '@/store/store';
import {ref} from "vue";
// group은 본사, 생산본부, Biz본부, 대리점
// type은 ADMIN, STAFF
export function checkPermission(group, type) {
    const token = store.state.loginModule.accessToken;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const tokenPayload = JSON.parse(decodeURIComponent(escape(window.atob(base64))));
    return tokenPayload.roles.some(role => {
        const parts = role.split('_');
        return parts.length > 1 && parts[1] === type && tokenPayload.groupType === group;
    });
}
const checkTokenInfo = () => {
    const token = store.state.loginModule.accessToken;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const tokenPayload = JSON.parse(decodeURIComponent(escape(window.atob(base64))));
    return tokenPayload;
}
const checkRole = () => {
    let role;
    role = checkTokenInfo().roles[0].split('_');
    return role[1];
};
export const componentPermission = async () => {
    let group = checkTokenInfo().groupType;
    store.dispatch('setGroupType', group);
    let role = checkRole();
    let permission;
    const selectedContinent = `${process.env.VUE_APP_CONTINENT}`; //대륙구분

    switch (group) {
        case '대동': //국내(추후 삭제)
        case '본사': //국내(추후 삭제)
        case 'KIOTI':
        case 'Deadong': //해외
            if (role == 'ADMIN') {
                permission = {
                    production : ['R', 'U'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : ['C','R','U'], //모델관리
                    deviceMng : ['R', 'U'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R', 'U'], //소모품관리
                    report : ['R', 'U'], //고장신고
                    sosCall : ['R', 'U'], //SOS호출
                    osTransMng : ['R', 'U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U', 'D'], //조직관리
                    userAppMng : ['C', 'R', 'U', 'D'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['C', 'R', 'U', 'D'], //공지사항관리
                    faqMng : ['C', 'R', 'U', 'D'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램

                    gptBanMng : ['C', 'R', 'U'], //GPT배너관리
                    administrator : ['R'],  //관리자 기능
                    memberHistory : ['R'], //조직 사용자 이력
                    promotionMng : ['C', 'R', 'U', 'D'], //프로모션 관리
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R','U'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R','U'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C','R','U'], //조직관리
                    userAppMng : ['R','U'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R','U'], //공지사항관리
                    faqMng : ['C','R','U'], //FAQ관리
                    postMng : ['R'], //게시판관리

                    remote : ['R','U'], //원격진단
                    afterService : ['R','U'], //애프터서비스
                    reprogram : ['R'], //리프로그램

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    gptBanMng : ['R'], //GPT배너관리
                    administrator : ['R'],  //관리자 기능
                    memberHistory : ['R'], //조직 사용자 이력
                    promotionMng : ['C', 'R', 'U'], //프로모션 관리
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case '서비스사업팀': //국내(추후 삭제)
        case 'Service Business Team': //해외
            if (role == 'ADMIN') {
                permission = {
                    production : ['R','U'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : ['C', 'R', 'U'], //모델관리
                    deviceMng : ['R','U'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R','U'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C','R','U','D'], //조직관리
                    userAppMng : ['C','R','U','D'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['C','R','U','D'], //공지사항관리
                    faqMng : ['C','R','U','D'], //FAQ관리
                    postMng : ['C','R','U','D'], //게시판관리

                    remote : ['R','U'], //원격진단
                    afterService : ['R','U'], //애프터서비스
                    reprogram : ['R','U'], //리프로그램

                    cateMng : ['C','R','U'], //카테고리관리
                    banMng : ['C','R','U'], //배너관리
                    partsCons : ['C','R','U'], //부품/소모품진열
                    administrator : ['R'],  //관리자 기능 
                    memberHistory : ['R'], //조직 사용자 이력
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : ['R'], //조직관리
                    userAppMng : ['R'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['R'], //게시판관리

                    remote : ['R'], //원격진단
                    afterService : ['R'], //애프터서비스
                    reprogram : ['R'], //리프로그램

                    cateMng : ['R'], //카테고리관리
                    banMng : ['R'], //배너관리
                    partsCons : ['R'], //부품/소모품진열
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case '생산': //국내(추후 삭제)
        case '생산본부': //국내(추후 삭제)
        case 'Production':
        case 'Production Headquarters': //해외 
            if (role == 'ADMIN') {
                permission = {
                    production : ['R', 'U'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R', 'U'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : [], //소모품관리
                    report : ['R', 'U'], //고장신고
                    sosCall : ['R', 'U'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : [], //고객관리

                    driveData : [], //차량운행데이터
                    operationData : [], //차량운영데이터

                    noticeMng : [], //공지사항관리
                    faqMng : [], //FAQ관리
                    postMng : [], //게시판관리
                    
                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                    administrator : ['R'],  //관리자 기능 
                    memberHistory : ['R'], //조직 사용자 이력
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : [], //고객관리

                    driveData : [], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['R'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case 'Biz본부': //국내(추후 삭제)
        case 'BIZ 본부': //국내(추후 삭제)
        case 'BIZ본부': //국내(추후 삭제)
        case 'CustomerBiz부문': //국내(추후 삭제)
        case 'CustomerBiz Division': //해외
        case 'Sales':
            if (role == 'ADMIN') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R','U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R','U'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['R','U'], //조직관리
                    userAppMng : [], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열
                    
                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R','U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R','U'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['R','U'], //조직관리
                    userAppMng : [], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case'국내영업본부': //국내(추후 삭제)
        case 'Domestic Sales Headquarters': //해외
        case 'RSM':
            if (role == 'ADMIN') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R', 'U'], //고장신고 — 상태변경 ADMIN 허용 (DDAT-1472)
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U'], //조직관리
                    userAppMng: selectedContinent === 'Europe' ? ['C', 'R', 'U', 'D'] : [], // 고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U'], //조직관리
                    userAppMng: selectedContinent === 'Europe' ? ['C', 'R', 'U', 'D'] : [], // 고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            }
            store.dispatch('setPermission', permission);
            break;
        case 'TSM':
            if (role == 'ADMIN') {
                permission = {
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R', 'U'], //고장신고 — 상태변경 ADMIN 허용 (DDAT-1472)
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U'], //조직관리
                    userAppMng: selectedContinent === 'Europe' ? ['C', 'R', 'U', 'D'] : [], // 고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리
                    
                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            } else if (role == 'STAFF') {
                permission = {
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R','U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U'], //조직관리
                    userAppMng: selectedContinent === 'Europe' ? ['C', 'R', 'U', 'D'] : [], // 고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                    administrator : [],  //관리자 기능
                    memberHistory : [], //조직 사용자 이력
                    promotionMng : ['R', 'U'], //프로모션 관리
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case '사업팀': //국내(추후 삭제)
        case 'Business Team': //해외
            if (role == 'ADMIN') {
                permission = {
                    production : ['R', 'U'], //생산관리
                    infoCheck : ['R', 'U'], //출하/판매정보조회
                    vehicleSttsMng : ['R', 'U'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R', 'U'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R', 'U'], //소모품관리
                    report : ['R', 'U'], //고장신고
                    sosCall : ['R', 'U'], //SOS호출
                    osTransMng : ['R', 'U'], //소유권이전관리

                    orgMng : ['C', 'R', 'U', 'D'], //조직관리
                    userAppMng : ['C', 'R', 'U', 'D'], //고객관리

                    driveData : [], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['C', 'R', 'U', 'D'], //공지사항관리
                    faqMng : ['C', 'R', 'U', 'D'], //FAQ관리
                    postMng : ['C', 'R', 'U', 'D'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : ['R'],  //관리자 기능 
                    memberHistory : ['R'], //조직 사용자 이력
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : ['R'], //모델관리
                    deviceMng : ['R'], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : ['R'], //조직관리
                    userAppMng : ['R'], //고객관리

                    driveData : [], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : ['R'], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R'], //원격진단
                    afterService : ['R'], //애프터서비스
                    reprogram : ['R'], //리프로그램
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case '지역': //국내(추후 삭제)
        case 'Region': //해외
            if (role == 'ADMIN') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : ['C','R','U','D'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : [], //공지사항관리
                    faqMng : [], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                    administrator : ['R'],  //관리자 기능 
                    memberHistory : ['R'], //조직 사용자 이력
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : ['R'], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : ['C', 'R'], //RDI관리

                    consMng : ['R'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : ['R','U'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : ['U'], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : [], //공지사항관리
                    faqMng : [], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : [], //원격진단
                    afterService : [], //애프터서비스
                    reprogram : [], //리프로그램
                }
            }
            store.dispatch('setPermission', permission);
            break;

        case '대리점': //국내(추후 삭제)
        case 'Agency': //해외
        case 'Dealers':
            if (role == 'ADMIN') {
                permission = {
                    production : [], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : selectedContinent === 'Europe' ? [] : ['C','R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R', 'U'], //고장신고 — 상태변경 ADMIN 허용 (DDAT-1472)
                    sosCall : selectedContinent === 'Europe' ? ['R'] : ['R','U'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : [], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : ['R'],  //관리자 기능
                    memberHistory : ['R'], //조직 사용자 이력
                }
            } else if (role == 'STAFF') {
                permission = {
                    production : [], //생산관리
                    infoCheck : ['R'], //출하/판매정보조회
                    vehicleSttsMng : ['R'], //차량현황관리
                    modelMng : [], //모델관리
                    deviceMng : [], //단말기관리
                    rdiMng : selectedContinent === 'Europe' ? [] : ['R'], //RDI관리

                    consMng : ['R','U'], //소모품관리
                    report : ['R'], //고장신고
                    sosCall : selectedContinent === 'Europe' ? ['R'] : ['R','U'], //SOS호출
                    osTransMng : ['R'], //소유권이전관리

                    orgMng : [], //조직관리
                    userAppMng : [], //고객관리

                    driveData : ['R'], //차량운행데이터
                    operationData : ['R'], //차량운영데이터

                    noticeMng : ['R'], //공지사항관리
                    faqMng : ['R'], //FAQ관리
                    postMng : [], //게시판관리

                    cateMng : [], //카테고리관리
                    banMng : [], //배너관리
                    partsCons : [], //부품/소모품진열

                    remote : ['R', 'U'], //원격진단
                    afterService : ['R', 'U'], //애프터서비스
                    reprogram : ['R', 'U'], //리프로그램
                    administrator : ['R'],  //관리자 기능
                    memberHistory : ['R'], //조직 사용자 이력
                }
            }
            store.dispatch('setPermission', permission);
            break;
    }
}
